export default {
  name: 'groupbuy_activity_order_sel',
  props: {
    currentActivity: {
      type: String
    },
    currentGroup: {
      type: String
    }
  },
  data: function data() {
    return {
      searchForm: {
        page: 1,
        limit: 5,
        state: 'pay',
        userNickname: '',
        refundUseState: true,
        groupCaptainState: true,
        activityId: this.currentActivity,
        sortField: 'create_time'
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0
    };
  },
  mounted: function mounted() {
    this.query();
  },
  methods: {
    sel: function sel(rowData) {
      this.$emit('child-activity-order-sel', rowData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    },
    query: function query() {
      var _this = this;
      this.queryLoading = true;
      this.$api.groupBuyActivityOrderQuery(this.searchForm).then(function (res) {
        _this.tableData = res.data || [];
        _this.totalCount = res.count;
        _this.queryLoading = false;
      });
    }
  }
};